import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import classNames from 'classnames';

import ResourcesList from 'components/ResourcesList';
import Resource from 'components/ResourcesList/Resource';
import ChatState from './ChatState';
import ChatInfoScheduledSession from './ChatInfoScheduledSession';
import { getChatResources, getFirstChatScheduledSessionStartDate } from 'selectors';
import * as actions from 'actions';
import './style.scss';

class ChatInfo extends Component {

  componentDidMount() {
    this.props.onDidMount();
  }

  render() {
    const scheduledChatSessionStartDate = this.props.scheduledChatSessionStartDate && moment(this.props.scheduledChatSessionStartDate);
    const className = classNames(
      'ChatInfo',
      {
        'is-centered': this.props.isCentered
      }
    );

    return (
      <div className={className}>
        <div className="wrapper-full">
          <ChatInfoScheduledSession scheduledChatSessionStartDate={scheduledChatSessionStartDate} />
          <ChatState scheduledChatSessionStartDate={scheduledChatSessionStartDate} />

          {(() => {
            if(this.props.shouldShowLatestChatResources) {
              return (
                <ResourcesList>
                  {this.props.latestChatResources.map(chatResource => {
                    const key = chatResource.sentAt + '_' + chatResource.data.url;

                    return (
                      <Resource
                        key={key}
                        title={chatResource.metadata.title}
                        authorName={chatResource.sender}
                        isWebsite
                        url={chatResource.data.url}
                      />
                    );
                  })}
                </ResourcesList>
              );
            }
          })()}
        </div>
      </div>
    );
  }
}

ChatInfo.propTypes = {
  shouldShowLatestChatResources: PropTypes.bool,
  latestChatResources: PropTypes.array,
  scheduledChatSessionStartDate: PropTypes.string,
  onDidMount: PropTypes.func,
  isCentered: PropTypes.bool
};

const mapStateToProps = (state) => {
  const latestChatResources = getChatResources(state, { page: 1, limit: 3 });

  return {
    scheduledChatSessionStartDate: getFirstChatScheduledSessionStartDate(state),
    shouldShowLatestChatResources: latestChatResources.length > 0,
    latestChatResources
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onDidMount: () => {
      dispatch(actions.chatResourcesFetch());
      dispatch(actions.chatScheduleFetch());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatInfo);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Mail/MailThreadsList/ChatInfo/index.js
 **/